export function newsFunc() {
  const root = document.querySelector('.p-news-archive');
  if (!root) return;

  const content = root.querySelector('[data-news-content]');
  const catNav = root.querySelector('.p-news-archive__categories');
  if (!content) return;

  const endpoint = (window.mahitoNews && window.mahitoNews.endpoint) || '';
  if (!endpoint) return;

  const getActiveCat = () => {
    const active = catNav ? catNav.querySelector('.p-news-archive__category.is-active') : null;
    return active ? parseInt(active.getAttribute('data-cat'), 10) || 0 : 0;
  };

  let currentCat = getActiveCat();
  let isLoading = false;

  const setActiveCat = (cat) => {
    if (!catNav) return;
    catNav.querySelectorAll('.p-news-archive__category').forEach((el) => {
      const elCat = parseInt(el.getAttribute('data-cat'), 10) || 0;
      el.classList.toggle('is-active', elCat === cat);
    });
  };

  const buildUrl = (cat, paged) => {
    const url = new URL(window.location.href);
    url.searchParams.delete('cat');
    url.searchParams.delete('paged');
    if (cat > 0) url.searchParams.set('cat', cat);
    if (paged > 1) url.searchParams.set('paged', paged);
    return url.pathname + url.search;
  };

  const scrollToTop = () => {
    const header = document.querySelector('.l-header');
    const offset = header ? header.offsetHeight : 0;
    const top = root.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  };

  const load = (cat, paged, push, doScroll) => {
    if (isLoading) return;
    isLoading = true;
    content.classList.add('is-loading');

    const url = new URL(endpoint, window.location.origin);
    url.searchParams.set('cat', cat);
    url.searchParams.set('paged', paged);

    fetch(url.toString(), {
      method: 'GET',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
    })
      .then((res) => res.json())
      .then((res) => {
        if (!res || typeof res.html === 'undefined') return;

        content.innerHTML = res.html;
        currentCat = cat;
        setActiveCat(cat);

        if (push) {
          window.history.pushState({ cat, paged }, '', buildUrl(cat, paged));
        }

        if (doScroll) scrollToTop();
      })
      .finally(() => {
        isLoading = false;
        content.classList.remove('is-loading');
      });
  };

  root.addEventListener('click', (e) => {
    const catLink = e.target.closest('[data-cat]');
    if (catLink && root.contains(catLink)) {
      e.preventDefault();
      const cat = parseInt(catLink.getAttribute('data-cat'), 10) || 0;
      if (cat === currentCat) return;
      load(cat, 1, true, false);
      return;
    }

    const pageLink = e.target.closest('[data-page]');
    if (pageLink && content.contains(pageLink)) {
      e.preventDefault();
      const paged = parseInt(pageLink.getAttribute('data-page'), 10) || 1;
      load(currentCat, paged, true, true);
    }
  });

  window.addEventListener('popstate', () => {
    const params = new URLSearchParams(window.location.search);
    const cat = parseInt(params.get('cat'), 10) || 0;
    const paged = parseInt(params.get('paged'), 10) || 1;
    load(cat, paged, false, false);
  });
}
